import { Uuid } from "@/domains/global/identifiers";
import { api } from "@/modules/api";
import { useQuery } from "@tanstack/react-query";

import { FC } from "react";
import { useParams } from "react-router";

export const DataImportItemsViewPage: FC = () => {
  const { dataImportItemId } = useParams<{ dataImportItemId: Uuid }>();

  if (!dataImportItemId) {
    return <div>Invalid ID</div>;
  }

  const result = useQuery({
    queryKey: ["data-import-item-by-id", dataImportItemId],
    queryFn: () =>
      api.get("/internal/v1/data-import-items/{data_import_item_id}", {
        params: {
          path: {
            data_import_item_id: dataImportItemId,
          },
        },
      }),
  });

  return (
    <div>
      <h1>View Data Import Item</h1>
      <pre>{JSON.stringify(result.data, null, 2)}</pre>
    </div>
  );
};
